import React from 'react';

function UnorderedList({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      // @ts-ignore TS(2783): 'stroke' is specified more than once, so this usag... Remove this comment to see the full error message
      stroke="black"
      {...otherProps}
    >
      <path d="M10 5H19" />
      <circle cx="6" cy="5" r="1.35" />
      <path d="M10 12H19" />
      <circle cx="6" cy="12" r="1.35" />
      <path d="M10 19H19" />
      <circle cx="6" cy="19" r="1.35" />
    </svg>
  );
}

export default UnorderedList;
